import { render, staticRenderFns } from "./ProductDynamicComponent.vue?vue&type=template&id=7ef564bb&scoped=true&"
import script from "./ProductDynamicComponent.vue?vue&type=script&lang=js&"
export * from "./ProductDynamicComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductDynamicComponent.vue?vue&type=style&index=0&id=7ef564bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef564bb",
  null
  
)

export default component.exports